//
//
//
//
//
//
//
//
//

import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    methods: {
        open() {
            this.$refs.input.open();
        },
    },
};
